/* Vollene · Knedlíčkov PDP */
(function () {
  'use strict';
  if (window.__vlPdp) return;
  window.__vlPdp = true;

  function scopeOf(el) {
    return el.closest('.shopify-section') || document;
  }

  function setAtcLabel(scope, label) {
    var btn = scope.querySelector('product-form-component button[name="add"], form[action*="/cart/add"] button[name="add"]');
    if (!btn || !label) return;
    var node = null;
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) { node = n; break; }
    }
    if (!btn.dataset.vlOrig) btn.dataset.vlOrig = node ? node.nodeValue.trim() : '';
    if (node) node.nodeValue = label;
    else btn.insertBefore(document.createTextNode(label), btn.querySelector('.add-to-cart__added'));
    btn.setAttribute('aria-label', label);
  }

  function setQty(scope, qty) {
    var input = scope.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    if (!input) return;
    input.value = String(qty);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function select(offer, tier) {
    var tiers = offer.querySelectorAll('.vl-tier');
    tiers.forEach(function (t) {
      var on = t === tier;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var scope = scopeOf(offer);
    setQty(scope, parseInt(tier.dataset.qty, 10) || 1);
    setAtcLabel(scope, tier.dataset.cta);
  }

  function initOffer(offer) {
    if (offer.dataset.vlReady) return;
    offer.dataset.vlReady = '1';
    var tiers = Array.prototype.slice.call(offer.querySelectorAll('.vl-tier'));
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { select(offer, t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, next = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') next = tiers[(i + 1) % tiers.length];
        if (k === 'ArrowUp' || k === 'ArrowLeft') next = tiers[(i - 1 + tiers.length) % tiers.length];
        if (next) { e.preventDefault(); select(offer, next); next.focus(); }
      });
    });
    var start = offer.querySelector('.vl-tier[aria-checked="true"]') || tiers[0];
    if (start) {
      select(offer, start);
      /* Horizon může formulář překreslit až po načtení – zopakujeme */
      setTimeout(function () { select(offer, offer.querySelector('.vl-tier[aria-checked="true"]') || start); }, 600);
    }
  }

  /* Tlačítka "vyber balení" v sekcích pod buy boxem */
  function initJumps() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-vl-jump]');
      if (!a) return;
      var offer = document.querySelector('.vl-offer');
      if (!offer) return;
      e.preventDefault();
      var want = a.getAttribute('data-vl-jump');
      var tier = want ? offer.querySelector('.vl-tier[data-qty="' + want + '"]') : null;
      if (tier) select(offer, tier);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      offer.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* Odpočet do 1. prosince (čas Praha) */
  function daysToAdvent() {
    var now = new Date();
    var y = now.getFullYear();
    var target = new Date(Date.UTC(y, 11, 1, -1, 0, 0)); /* 1. 12. 00:00 CET */
    if (now > new Date(Date.UTC(y, 11, 24, 23, 0, 0))) target = new Date(Date.UTC(y + 1, 11, 1, -1, 0, 0));
    var d = Math.ceil((target - now) / 86400000);
    return d;
  }

  function czDays(n) {
    if (n === 1) return 'den';
    if (n >= 2 && n <= 4) return 'dny';
    return 'dní';
  }

  function initCountdowns() {
    var n = daysToAdvent();
    document.querySelectorAll('[data-vl-days]').forEach(function (el) {
      var box = el.closest('[data-vl-days-wrap]');
      if (n <= 0) { if (box) box.hidden = true; return; }
      el.textContent = n + ' ' + czDays(n);
    });
  }

  function init() {
    document.querySelectorAll('.vl-offer').forEach(initOffer);
    initCountdowns();
  }

  initJumps();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
